import { render, staticRenderFns } from "./ImportNotifications.vue?vue&type=template&id=818d8600"
import script from "./ImportNotifications.vue?vue&type=script&lang=js"
export * from "./ImportNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports